<script>
    import { slide } from 'svelte/transition';

    import { createEventDispatcher } from 'svelte';
    import { uiText } from '../lib/uiText.js';
    export let lang;

    const dispatch = createEventDispatcher();
    let ui = uiText(lang);
    $: lang, (ui = uiText(lang)), dispatch('setLang', { lang: lang, prefset: true });
</script>

<div
    transition:slide
    class="grid m-[10px] p-[15px] obelisk bg-blue-100 bg-opacity-40 place-content-center place-self-center place-items-center"
>
    <h1 class="text-yellow">{ui.game.bonus_riddle_title}</h1>
    <p class="mb-2">{ui.game.bonus_riddle_description}</p>

    <button
        class="justify-center place-self-center outline"
        on:click={() => dispatch('skipBonus', 'skipBonus')}
    >
        <i class="fa-solid fa-ban" data-position="left" />
        {ui.game.bonus_riddle_skip}
    </button>
</div>

<style>
    div {
        border: 2px solid #f7db00;
    }
</style>
